import { render, staticRenderFns } from "./AddJurnal.vue?vue&type=template&id=4d7751a0&scoped=true&"
import script from "./AddJurnal.vue?vue&type=script&lang=js&"
export * from "./AddJurnal.vue?vue&type=script&lang=js&"
import style0 from "./AddJurnal.vue?vue&type=style&index=0&id=4d7751a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7751a0",
  null
  
)

export default component.exports